export const getDistanceBetweenPoints = (
  coord1: [number, number],
  coord2: [number, number]
) => {
  const dLat = deg2rad(coord1[0] - coord2[0]); // deg2rad below
  const dLon = deg2rad(coord1[1] - coord2[1]);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(coord1[0])) *
      Math.cos(deg2rad(coord2[0])) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = 6371e3 * c; // Distance in m
  return parseInt(d.toFixed(2));
};

const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};
